import React, { useEffect, useState } from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';

/**
 * Celebratory strip that slides down above the #1 school card after the
 * parent upgrades. Auto-dismisses after 8s; stays clickable/visible until
 * then. Rendered only when `show` is true.
 */
const UnlockBanner = ({ show, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    setVisible(true);
    const t = setTimeout(() => {
      setVisible(false);
      if (onDismiss) setTimeout(onDismiss, 400);
    }, 8000);
    return () => clearTimeout(t);
  }, [show, onDismiss]);

  if (!show) return null;

  return (
    <div
      data-testid="full-report-unlocked-banner"
      aria-live="polite"
      className={
        'overflow-hidden transition-all duration-500 ease-out ' +
        (visible ? 'max-h-32 opacity-100 mb-4' : 'max-h-0 opacity-0 mb-0')
      }
    >
      <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-4 flex items-start gap-3 shadow-[0_4px_14px_rgba(16,185,129,0.15)]">
        <div className="flex-none mt-0.5">
          <CheckCircle2 className="w-6 h-6 text-emerald-600" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="flex items-center gap-2 text-sm font-bold text-emerald-800">
            <Sparkles className="w-4 h-4" aria-hidden="true" />
            Full report unlocked
          </p>
          <p className="text-sm text-emerald-900/80 mt-0.5">
            Verified exam data, accreditations, pastoral-care signals and fee-forecast comparisons are now visible on every match below.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnlockBanner;
